import { type SvgProps, SvgWrapper } from '../utils';

export function BlockIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C9.71568 2.75 7.62547 3.57888 6.01172 4.95117L19.0469 17.9873C20.4194 16.3735 21.25 14.2845 21.25 12ZM2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C14.284 21.25 16.3727 20.4198 17.9863 19.0479L4.95117 6.01172C3.57888 7.62547 2.75 9.71568 2.75 12ZM22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12Z" />
    </SvgWrapper>
  );
}
